const rewriteSlugs = {
  signUpModal: {
    source: 'registrace',
    queryKey: 'signUp',
  },
}

exports.rewriteSlugs = rewriteSlugs
exports.modalSlugsRewriteRules = {
  beforeFiles: [
    {
      source: `/${rewriteSlugs.signUpModal.source}`,
      destination: `/?modal=${rewriteSlugs.signUpModal.queryKey}`,
    },
    {
      source: `/${rewriteSlugs.signUpModal.source}/`,
      destination: `/?modal=${rewriteSlugs.signUpModal.queryKey}`,
    },
    {
      source: `/:path*/${rewriteSlugs.signUpModal.source}`,
      destination: `/:path*?modal=${rewriteSlugs.signUpModal.queryKey}`,
    },
    {
      source: `/:path*/${rewriteSlugs.signUpModal.source}/`,
      destination: `/:path*?modal=${rewriteSlugs.signUpModal.queryKey}`,
    },
  ],
}
